module.exports = __webpack_public_path__ + "static/outlook_local_1-db354d75a2345479e021392392601dba.png";